<template>
	<div class="owl-carousel" :key='new Date().getTime()'>
		<!-- <pre>{{items}}</pre> -->
		<template v-for='item in items'>
			<!-- <pre>{{item}}</pre> -->
			<div class="item">
				<div class="image" :style='`background-image: url(${item.img})`'></div>
			</div>
		</template>
	</div>
</template>

<script>
module.exports = {

	props: ['data'],

	data () {
		return { }
	},

	computed: {
		items() {
			return this.data ? this.data.items : [];
		}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				// loop: false,
				nav: true,
				dots: true,
				navSpeed: 1000,
				dragEndSpeed: 1000,
				dotsSpeed: 100,
				onTranslate: () => {
					this.$parent.$el.classList.add('disabled');
				},
				onTranslated: () => {
					this.$parent.$el.classList.remove('disabled');
				}
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.global-slider-container {

	&.disabled {
		.slider-project-slider-1 {
			@include pointer-events(none);
			touch-action: manipulation;
		}
	}

	.slider-project-slider-1 {
		// overflow: hidden;
		touch-action: manipulation;
		position: relative;
		padding: 0 15px;
		height: 270px;
		margin: 0 0 60px;
		// background-color: rgba(blue, .1);
		@include s___up {
			height: 320px;
		};
		@include m_up {
			height: 420px;
			margin: 0 0 86px;
		};
		@include m__up {
			width: 580px;
			margin: 0 auto 131px;
			padding: 24px 41px 0 48px;
			&:after {
				content: '';
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				// background-color: rgba(green, .1);
				background: url('#{$imgPathSCSS}tablet-3.png') no-repeat center;
				background-size: 100% 100%;
				@include pointer-events(none);
				touch-action: manipulation;
			}
		};
		@include m___up {
			width: 770px;
			height: 540px;
			margin: 0 auto 138px;
			padding: 31px 55px 0 64px;
		};
		@include l___up {
			width: 908px;
			height: 627px;
			padding: 36px 64px 0 75px;
			margin: 0 auto 151px;
		};


		.owl-carousel {

			.owl-stage-outer {
				overflow: visible;
				margin: 0 0 10px;
			}

			.owl-item {
				transition: all 1000ms ease 0ms;

				&.active {
					z-index: 1;
				}
			}

			.owl-item:not(.active) {
				opacity: .5;
				transform: perspective(1000px) scale(1.3) rotateY(60deg) translateX(170px);
				transition: all 1000ms ease 0ms;
				@include m___up {
					transform: perspective(1000px) scale(1.3) rotateY(60deg) translateX(350px) translateY(-30px);
				};
				@include l__up {
					transform: perspective(1000px) scale(1.25) rotateY(45deg) translateX(120px) translateY(0);
				};
			}
			.owl-item.active + .owl-item,
			.owl-item.active + .owl-item + .owl-item {
				transform: perspective(1000px) scale(1.3) rotateY(-60deg) translateX(-170px);
				opacity: .5;
				transition: all 1000ms ease 0ms;
				@include m___up {
					transform: perspective(1000px) scale(1.3) rotateY(-60deg) translateX(-350px) translateY(-30px);
				};
				@include l__up {
					transform: perspective(1000px) scale(1.25) rotateY(-45deg) translateX(-120px) translateY(0);
				};
			}

			.item {

				.image {
					background-position: center top;
					background-size: cover;
					height: 220px;
					// border: 2px solid #aaa;
					// border-radius: 2px;
					@include s___up {
						height: 270px;
					};
					@include m_up {
						height: 373px;
					};
					@include m___up {
						height: 479px;
					};
					@include l___up {
						height: 557px;
					};
				}
			}

			.owl-nav {
				height: 50px;
				// background-color: rgba(red, .1);
				display: flex;
				justify-content: space-between;
				align-items: center;

				.owl-prev, .owl-next {
					width: 32px;
					height: 32px;
					font-size: 0;
					background: url('#{$imgPathSCSS}ps1-prev.png') no-repeat center;
					background-size: 100% 100%;
					border: none;
					@include single-transition;
					@include m__up {
						width: 50px;
						height: 50px;
						position: absolute;
						top: calc(50% - 25px);
					};
					@include l___up {
						width: 86px;
						height: 86px;
						top: calc(50% - 44px);
					};

					&:hover {
						background-image: url('#{$imgPathSCSS}ps1-prev-a.png');
					}
				}

				.owl-prev {
					@include m__up {
						left: -55px;
					};
					@include m___up {
						left: -79px;
					};
					@include l___up {
						left: -340px;
					};
				}

				.owl-next {
					@include rotate(180deg);
					@include m__up {
						right: -55px;
					};
					@include m___up {
						right: -79px;
					};
					@include l___up {
						right: -340px;
					};
				}
			}

			.owl-dots {
				position: absolute;
				left: 50px;
				right: 50px;
				bottom: -10px;
				height: 50px;
				// background-color: rgba(green, .1);
				display: flex;
				justify-content: center;
				align-items: center;
				@include pointer-events(none);
				touch-action: manipulation;
				@include m__up {
					bottom: -65px;
				};
				@include m___up {
					bottom: -85px;
				};
				@include l___up {
					bottom: -112px;
				};

				.owl-dot {
					border: 2px solid #BABABD;
					position: relative;
					border-radius: 100%;
					opacity: .5;
					width: 12px;
					height: 12px;
					margin: 0 4px;
					@include single-transition;
					@include m__up {
						width: 18px;
						height: 18px;
						margin: 0 7px;
					};

					&.active {
						opacity: 1;
						&:after {
							opacity: 1;
						}
					}

					&:after {
						content: '';
						display: block;
						background-color: #BABABD;
						position: absolute;
						border-radius: 100%;
						opacity: 0;
						@include single-transition;
						width: 4px;
						height: 4px;
						top: calc(50% - 2px);
						left: calc(50% - 2px);
						@include m__up {
							width: 6px;
							height: 6px;
							top: calc(50% - 3px);
							left: calc(50% - 3px);
						};
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// project-slider-1.vue?150ee26a